import { Controller } from "@hotwired/stimulus"

// Global variables from lightGallery CDN
declare const lightGallery: any
declare const lgZoom: any
declare const lgThumbnail: any

export default class extends Controller<HTMLElement> {
  static values = {
    images: Array
  }

  declare readonly imagesValue: string[]
  private gallery: any

  connect(): void {
    this.initLightGallery()
  }

  disconnect(): void {
    if (this.gallery) {
      this.gallery.destroy()
    }
  }

  initLightGallery(): void {
    // lightGallery가 로드될 때까지 대기
    if (typeof lightGallery === "undefined") {
      setTimeout(() => this.initLightGallery(), 100)
      return
    }

    // 동적으로 갤러리 아이템 생성
    const dynamicEl = this.imagesValue.map((src, index) => ({
      src: src,
      thumb: src,
      subHtml: `<p>${index + 1} / ${this.imagesValue.length}</p>`
    }))

    this.gallery = lightGallery(this.element, {
      dynamic: true,
      dynamicEl: dynamicEl,
      plugins: [lgZoom, lgThumbnail],
      speed: 300,
      download: false,
      counter: true,
      thumbnail: true,
      thumbWidth: 80,
      thumbHeight: 80,
      thumbMargin: 8,
      animateThumb: true,
      zoomFromOrigin: false,
      showMaximizeIcon: true,
      mobileSettings: {
        controls: true,
        showCloseIcon: true,
        download: false
      }
    })
  }

  open(event: Event): void {
    event.preventDefault()
    const target = event.currentTarget as HTMLElement
    const index = parseInt(target.dataset.index || "0", 10)
    if (this.gallery) {
      this.gallery.openGallery(index)
    }
  }
}
